import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import EventQuestionList from '../components/EventQuestionList';
import Question from '../components/Question';
import { hasQuestions } from 'checkout/selectors/questions';
import { isKioskMode } from '../../../selectors/ui';
import Translation from "../../../../shared/Translation";

class QuestionsContainer extends Component {
    render() {
        if(!this.props.hasQuestions) {
            return null;
        }

        if (this.props.isKioskMode) {
            return (
                <Fragment>
                    {this.getEventQuestionLists()}
                    {this.getOrderQuestionList()}
                </Fragment>
            );
        }

        return(
            <section className="checkout-form__section">
                <div className="form-card">
                    <div className="form-card__header">
                        <h4 className="form-card__heading"><Translation>{'checkout__please_answer_questions'}</Translation></h4>
                    </div>
                    <div className="form-card__content">
                        {this.getEventQuestionLists()}
                        {this.getOrderQuestionList()}
                    </div>
                </div>
            </section>
        )
    }

    getEventQuestionLists = () => {
      return Object.values(this.props.events).map((event, i) => (
        <EventQuestionList
          {...event}
          key={i}
          numEvents={2}
          tickets={this.props.tickets}
          priceLevels={this.props.priceLevels}
          bundles={this.props.bundles}
          bundleSales={this.props.bundleSales}
        />
      ));
    }

    getOrderQuestionList = () => {
        return this.props.orders.map((q, i) => {
            return <Question question={q} key={i}/>
        })
    }

}

const mapStateToProps = state => {
    return {
        events: state.questions.events,
        orders: state.questions.orders,
        numEvents: state.reservation.listings.length,
        hasQuestions: hasQuestions(state),
        isKioskMode: isKioskMode(state),
        tickets: state.tickets,
        priceLevels: state.priceLevel,
        bundles: state.bundles,
        bundleSales: state.bundleSales,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

QuestionsContainer.propTypes = {
    events: PropTypes.object,
    orders: PropTypes.array,
    numEvents: PropTypes.number,
    hasQuestions: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsContainer)
